const toggleDisplay = (condition, element) => {
  if (!condition) {
    // Save the current display attribute to data-original-display
    element.dataset.originalDisplay = element.style.display || '';
    element.style.display = 'none';
  } else {
    // Try to fetch the original display attribute, default to '' if not set
    element.style.display = element.dataset.originalDisplay || '';
  }
}

export { toggleDisplay }
